/*
 * Copyright (c) 2023. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: SeriesDetail.tsx
 * Project: mle-client-n
 * Committed last: 2023/3/14 @ 1547
 * ---
 * Description:
 */

import {SeriesDetails} from "../../../store/features/mpes-io/ExportFeature";
import {Card, Icon, Intent} from "@blueprintjs/core";

interface Props {
    details: SeriesDetails;
}

export const SeriesDetailThumbinail = (props: Props) => {
    return (
        <Card className="my-3">
            <Icon className="mr-2" icon="info-sign" intent={Intent.PRIMARY}/>
            <small className="bp4-text-muted">Verranno create <b>{props.details.pages}</b> pagine
                con <b>{props.details.labelsPerPage}</b> etichette ognuna. </small>
            {
                props.details.labelsPerPage == 0 &&
                <div className="text-red-700">Il margine inserito è troppo grande. </div>
            }
        </Card>
    )
}